import React from "react";
import {
    Box,
    Typography,
    Grid,
    useMediaQuery,
    useTheme,
    Stack,
} from "@mui/material";

const features = [
    {
        icon: "💡",
        title: "All In One Solution",
        description:
            "You will get a complete business communication solution with Picky Assist, don’t need to spend more for other softwares",
    },
    {
        icon: "😊",
        title: "Trusted Globally by Thousands",
        description:
            "Start your business journey with confidence. 2000+ customers in 80+ countries trust Picky Assist as their modern communication partner",
    },
    {
        icon: "🤝",
        title: "Facebook (Meta) & Google Partner",
        description:
            "Direct Integration with WhatsApp, Facebook & Instagram. Picky Assist is an authorized Facebook (Meta) & Google Partner.",
    },
    {
        icon: "🎧",
        title: "Guided Support and Tutorials",
        description:
            "We help you to onboard and get started without asking any extra charges for the first few sessions. Refer to our step-by-step tutorials.",
    },
    {
        icon: "👍",
        title: "We Build What You Need?",
        description:
            "We don’t build products simply because others are building; we build products and features when we see a gap.",
    },
    {
        icon: "👨‍💻",
        title: "24/7 Friendly Human Support",
        description:
            "Our friendly support team via Email (24 x 7) & Live Chat always available to assist when you land in trouble.",
    },
];

const TextSection2 = () => {
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down("sm"));
    const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const isMd = useMediaQuery(theme.breakpoints.up("md"));

    return (
        <Box sx={{ backgroundColor: "#f5f7fa", py: 6 }}>
            <Box
                sx={{
                    width: "100%",
                    maxWidth: "1300px",
                    mx: "auto",
                    px: { xs: 2, sm: 3, md: 4 },
                    textAlign: "center",
                }}
            >
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Why Choose Vertex Suite?
                </Typography>
                <Typography variant="body1" sx={{ mb: 4, color: "#555" }}>
                    We know there are competitors in the market and winning the customer’s
                    heart is possible only by answering “Why Picky Assist?” below are the
                    answers for you,
                </Typography>

                <Grid container spacing={4}>
                    {features.map((feature, index) => (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            key={index}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                textAlign: "center",
                                px: 2,
                            }}
                        >
                            <Box
                                sx={{
                                    fontSize: { xs: "40px", md: "50px", lg: "60px" },
                                    mb: 2,
                                }}
                            >
                                {feature.icon}
                            </Box>
                            <Typography variant="h6" fontWeight="bold" gutterBottom>
                                {feature.title}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                {feature.description}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
};

export default TextSection2;
